<template>
  <c-select
    v-model="selected"
    data-testid="collaborator-selector"
    density="comfortable"
    :label="t('asset.collaborator')"
    :items="collaboratorProfileItems"
    :item-title="(i) => getCollaboratorFullName(i as erpClient.CollaboratorProfileOutputDto)"
    item-value="uuid"
    :clearable="false"
    :menu-props="{ style: 'z-index: 1;' }"
    @update:model-value="onCollaboratorProfileSelect"
  ></c-select>
  <input
    id="select-input-proxy"
    :value="collaboratorProfileItems.map((item) => item.collaborator.uuid).join(', ')"
    type="hidden"
  />
</template>

<script lang="ts" setup>
import { ref, watch, onMounted, watchEffect } from 'vue';
import { getCollaboratorFullName } from './utils';
import { erpClient } from '@tfpl/api-client';
import CSelect from '@/components/Common/CSelect.vue';
import { ModelValue } from '@/types/common';
import { useI18n } from 'vue-i18n';

type EmitFn = (event: 'selectProfile', profile: erpClient.CollaboratorProfileOutputDto) => void;

const emit = defineEmits<EmitFn>();

const props = defineProps<{
  collaboratorProfiles: erpClient.CollaboratorProfileOutputDto[];
  selectedCollaboratorUuid?: string;
}>();

const collaboratorProfileItems = ref<erpClient.CollaboratorProfileOutputDto[]>([]);
const selected = ref<string | null>(null);
const { t } = useI18n();

let preventEmit = true;

const onCollaboratorProfileSelect = (uuid: ModelValue) => {
  const selectedProfile = props.collaboratorProfiles.find((profile) => profile.uuid === uuid);
  if (selectedProfile) {
    emit('selectProfile', selectedProfile);
  }
};

onMounted(() => {
  collaboratorProfileItems.value = [...props.collaboratorProfiles];

  if (props.selectedCollaboratorUuid) {
    selected.value = props.selectedCollaboratorUuid;
  }

  preventEmit = false;
});

watch(
  () => props.collaboratorProfiles,
  (newProfiles) => {
    collaboratorProfileItems.value = [...newProfiles];
  },
);

watch(
  () => props.selectedCollaboratorUuid,
  (newUuid) => {
    if (newUuid) {
      selected.value = newUuid;
    }
  },
);

// Handle reactivity for the selected value
watchEffect(() => {
  if (!preventEmit && selected.value) {
    onCollaboratorProfileSelect(selected.value);
  }
});
</script>
